import React from 'react';
import Icon from 'components/AppIcon';

const EmailInputForm = ({ email, setEmail, error, isLoading, onSubmit }) => {
  return (
    <>
      <div className="text-center mb-6">
        <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="KeyRound" size={24} className="text-primary" />
        </div>
        <h2 className="text-xl font-heading font-semibold text-text-primary mb-2">Forgot Your Password?</h2>
        <p className="text-sm text-text-secondary leading-relaxed">
          Enter the email address associated with your account and we'll send you a link to reset your password.
        </p>
      </div>

      {error && (
        <div className="bg-error-50 border border-error-100 text-error rounded-lg p-3 mb-4 text-sm flex items-start gap-2">
          <Icon name="AlertCircle" size={16} className="flex-shrink-0 mt-0.5" />
          <span>{error}</span>
        </div>
      )}

      <form onSubmit={onSubmit} className="space-y-5">
        <div>
          <label htmlFor="reset-email" className="block text-sm font-medium text-text-primary mb-2">
            Email Address
          </label>
          <div className="relative">
            <input
              type="email"
              id="reset-email"
              value={email}
              onChange={(e) => setEmail(e?.target?.value)}
              className="w-full px-4 py-3 pl-11 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-smooth bg-background text-text-primary placeholder-text-secondary"
              placeholder="your@email.com"
              disabled={isLoading}
              autoComplete="email"
              autoFocus
            />
            <Icon name="Mail" size={18} className="absolute left-3.5 top-3.5 text-text-secondary" />
          </div>
        </div>

        <button
          type="submit"
          disabled={isLoading}
          className="w-full bg-primary text-white py-3 px-4 rounded-lg font-medium hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 transition-smooth disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {isLoading ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
              <span>Sending Reset Link...</span>
            </>
          ) : (
            <>
              <Icon name="Send" size={18} />
              <span>Send Reset Link</span>
            </>
          )}
        </button>
      </form>

      <div className="mt-6 p-4 bg-background rounded-lg border border-border">
        <p className="text-xs text-text-secondary text-center leading-relaxed">
          <Icon name="ShieldCheck" size={14} className="inline mr-1 text-primary" />
          For security, the reset link expires in <strong>1 hour</strong>. Check your spam folder if you don't see the email.
        </p>
      </div>
    </>
  );
};

export default EmailInputForm;
